import { useTranslation } from 'react-i18next';
import TopNavigation from '../../components/base/TopNavigation';
import BottomNavigation from '../../components/base/BottomNavigation';

export default function ProfilePage() {
  const { t } = useTranslation();

  const profileOptions = [
    {
      icon: 'ri-user-settings-line',
      title: t('editProfile'),
      subtitle: 'تعديل المعلومات الشخصية',
      action: () => {}
    },
    {
      icon: 'ri-notification-3-line',
      title: t('notifications'),
      subtitle: 'إعدادات الإشعارات',
      action: () => {}
    },
    {
      icon: 'ri-group-line',
      title: 'إدارة العائلة',
      subtitle: 'الأعضاء والصلاحيات',
      action: () => {}
    },
    {
      icon: 'ri-global-line',
      title: 'اللغة',
      subtitle: 'العربية',
      action: () => {}
    },
    {
      icon: 'ri-shield-check-line',
      title: 'الخصوصية والأمان',
      subtitle: 'إعدادات الحماية',
      action: () => {}
    },
    {
      icon: 'ri-question-line',
      title: 'المساعدة والدعم',
      subtitle: 'الأسئلة الشائعة',
      action: () => {}
    }
  ];

  const familyMembers = [
    { name: 'محمد أحمد', role: 'مشرف', avatar: 'M', color: '#5B9BD5' },
    { name: 'فاطمة محمد', role: 'عضو', avatar: 'ف', color: '#F4A261' },
    { name: 'أحمد محمد', role: 'عضو', avatar: 'أ', color: '#81C784' },
    { name: 'سارة محمد', role: 'عضو', avatar: 'س', color: '#E57373' },
    { name: 'علي محمد', role: 'عضو', avatar: 'ع', color: '#9C27B0' }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50">
      <TopNavigation 
        title={t('profile')}
        rightAction={
          <button className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
            <i className="ri-settings-3-line text-lg"></i>
          </button>
        }
      />
      
      <div className="pt-16 pb-20 px-4">
        {/* User Profile */}
        <div className="bg-gradient-to-r from-[#5B9BD5] to-[#F4A261] rounded-2xl p-6 mb-6 text-white">
          <div className="flex items-center">
            <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mr-4">
              <span className="text-2xl font-bold">م</span>
            </div>
            <div className="flex-1">
              <h2 className="text-xl font-bold">محمد أحمد</h2>
              <p className="text-white/80 mb-2">mohammed@family.com</p>
              <div className="flex items-center">
                <i className="ri-shield-check-fill text-sm mr-1"></i>
                <span className="text-sm">مشرف العائلة</span>
              </div>
            </div>
          </div>
        </div>

        {/* Family Members */}
        <div className="bg-white rounded-2xl p-4 mb-6 shadow-sm">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-bold text-gray-800">أعضاء العائلة</h3>
            <button className="text-[#5B9BD5] text-sm font-medium">
              دعوة عضو
            </button>
          </div>
          <div className="space-y-3">
            {familyMembers.map((member, index) => (
              <div key={index} className="flex items-center">
                <div 
                  className="w-10 h-10 rounded-full flex items-center justify-center text-white font-medium mr-3"
                  style={{ backgroundColor: member.color }}
                >
                  {member.avatar}
                </div>
                <div className="flex-1">
                  <h4 className="font-medium text-gray-800">{member.name}</h4>
                  <p className="text-sm text-gray-500">{member.role}</p>
                </div>
                <i className="ri-more-2-line text-gray-400"></i>
              </div>
            ))}
          </div>
        </div>

        {/* Profile Options */}
        <div className="bg-white rounded-2xl p-4 mb-6 shadow-sm">
          <div className="space-y-1">
            {profileOptions.map((option, index) => (
              <button
                key={index}
                onClick={option.action}
                className="w-full flex items-center p-3 rounded-xl hover:bg-gray-50 transition-colors"
              >
                <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center mr-3">
                  <i className={`${option.icon} text-gray-600`}></i>
                </div>
                <div className="flex-1 text-right">
                  <h4 className="font-medium text-gray-800">{option.title}</h4>
                  <p className="text-sm text-gray-500">{option.subtitle}</p>
                </div>
                <i className="ri-arrow-left-s-line text-gray-400"></i>
              </button>
            ))}
          </div>
        </div>

        {/* App Info */}
        <div className="bg-white rounded-2xl p-4 mb-6 shadow-sm">
          <div className="text-center">
            <div className="w-16 h-16 bg-[#5B9BD5]/10 rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-home-heart-fill text-2xl text-[#5B9BD5]"></i>
            </div>
            <h3 className="font-bold text-gray-800 mb-1">{t('appName')}</h3>
            <p className="text-sm text-gray-500 mb-4">الإصدار 1.0.0</p>
            <div className="flex justify-center space-x-4 space-x-reverse">
              <button className="text-[#5B9BD5] text-sm">سياسة الخصوصية</button>
              <button className="text-[#5B9BD5] text-sm">شروط الاستخدام</button>
            </div>
          </div>
        </div>

        {/* Logout */}
        <button className="w-full bg-[#E57373] text-white py-4 rounded-2xl font-medium flex items-center justify-center">
          <i className="ri-logout-box-line mr-2"></i>
          {t('logout')}
        </button>
      </div>

      <BottomNavigation />
    </div>
  );
}